// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SmsSettingsResponse

import { SmsReviewUrlType } from './enums.gen';

export type SmsSettingsApiResponse = {
	id: number;
	sendBookingReminder: boolean;
	sendBookingReconfirmation: boolean;
	sendBookingReview: boolean;
	remainingCredits: number;
	minutesBeforeBookingReminder: number;
	reviewUrlType: SmsReviewUrlType;
	creditAutoRefillEnabled: boolean;
	creditAutoRefillAmount: number;
	creditAutoRefillThreshold: number;
};

export type SmsSettings = {
	id: number;
	sendBookingReminder: boolean;
	sendBookingReconfirmation: boolean;
	sendBookingReview: boolean;
	remainingCredits: number;
	minutesBeforeBookingReminder: number;
	reviewUrlType: SmsReviewUrlType;
	creditAutoRefillEnabled: boolean;
	creditAutoRefillAmount: number;
	creditAutoRefillThreshold: number;
};

export function hydrateSmsSettings(data: SmsSettingsApiResponse): SmsSettings {
	return { ...data };
}